<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.9.95a.75.75 0 0 1 .712.513L10.1 11.928l1.389-4.165a.75.75 0 0 1 .711-.513H15a.75.75 0 0 1 0 1.5h-2.26l-1.928 5.787a.75.75 0 0 1-1.424 0L5.9 4.072 4.512 8.237a.75.75 0 0 1-.712.513H1a.75.75 0 0 1 0-1.5h2.26l1.928-5.787A.75.75 0 0 1 5.9.95Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
</template>
